export type BillingTab =
  | 'encounters'
  | 'claims'
  | 'ops'
  | 'batch-runs'
  | 'acknowledgments'
  | 'remittances'
  | 'accounts';

export interface BillingTabItem {
  tab: BillingTab;
  label: string;
  to: string;
}

export const BILLING_TAB_ITEMS: BillingTabItem[] = [
  { tab: 'encounters', label: 'Encounters', to: '/dashboard/billing' },
  { tab: 'claims', label: 'Claims', to: '/dashboard/billing/claims' },
  { tab: 'batch-runs', label: 'Batch Runs', to: '/dashboard/billing/batch-runs' },
  { tab: 'acknowledgments', label: 'Acknowledgments', to: '/dashboard/billing/acknowledgments' },
  { tab: 'remittances', label: 'Remittances', to: '/dashboard/billing/remittances' },
  { tab: 'accounts', label: 'Accounts', to: '/dashboard/billing/accounts' },
  { tab: 'ops', label: 'Todos', to: '/dashboard/billing/ops' },
];

export function billingHidesSecondaryNav(pathname: string): boolean {
  return (
    /\/dashboard\/billing\/claims\/[^/]+\/cms1500$/.test(pathname) ||
    /\/dashboard\/billing\/eobs\/[^/]+$/.test(pathname)
  );
}

/** DEV Create control: development profile (including unset) and Billing list chrome. */
export function billingShowsDevCreate(pathname: string, profile?: string): boolean {
  return (profile || 'development') === 'development' && !billingHidesSecondaryNav(pathname);
}

export function billingActiveTab(pathname: string): BillingTab {
  if (billingHidesSecondaryNav(pathname)) {
    if (pathname.includes('/eobs/')) return 'remittances';
    return 'claims';
  }
  if (pathname === '/dashboard/billing/claims') return 'claims';
  const match = BILLING_TAB_ITEMS.find(
    (item) => item.to !== '/dashboard/billing' && pathname.startsWith(item.to),
  );
  if (match) return match.tab;
  return 'encounters';
}
